module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-28.08fed091.png";